/**
 * Every piece of UI that requires javascript should have its own
 * javascript file. Use this file as a template for structuring
 * all JS source files.
 *
 * Wave Animation Snapshot
 *
 * Takes a snapshot of the videos for mobile view
 */

const $ = require( 'jQuery' );

var ImgSnapshot = (el) => {
    //setup variables
    const $el    = $(el);
    const video = $el.find(".itbl-c-wave-animation__container").get(0);


    $(video).one('loadstart', (event) => {

        //create a canvas obj
        let canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d')
            .drawImage(video, 0, 0, canvas.width, canvas.height);


        //create an image element to append
        let img = document.createElement("img");
        img.src = canvas.toDataURL();
        img.classList.add('hide-for-medium', 'itbl-c-snapshot');

        $el.append(
            $('<figure />')
                .append(img)
        );

        video.classList.add( 'show-for-medium' );

    });

};
